<template>
  <div class="heading-one">
    <div class="border"></div>
    <h1 class="heading"><slot></slot></h1>
  </div>
</template>

<script>
export default {
  name: 'heading-one'
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.heading-one {
  @include flex(flex,flex-start,stretch,row,nowrap);
  width: 100%;
  // padding-top: 20px;
  // padding-bottom: 20px;
  margin-bottom: 20px;
  @include mq-up(md) {
    margin-bottom: 30px;
  }
  &.-margin-md {
    margin-top: 20px;
    margin-bottom: 20px;
    @include mq-up(md) {
      margin-top: 60px;
      margin-bottom: 60px;
    }
  }
  > .border {
    width: 5px;
    @include mq-up(md) {
    width: 8px;
    }
    background: #eb5505;
    border-radius: 4px;
  }
  > .heading {
    width: calc(100% - 8px);
    font-size: 40px;
    line-height: 40px;
    color: #333;
    padding: 5px 0 5px 15px;
    @include mq-down(md) {
      padding: 3px 0 3px 10px;
      font-size: 24px;
      line-height: 28px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/heading/HeadingOne.vue